<template>
  <div>
    <p class="lg:text-lg text-black sm-fsize16 mb-8">
      A Homecare Professional is someone who provides care and assistance to
      people who are unable to care for themselves due to illness, injury, or
      disability.
    </p>
    <p class="text-black text-lg font-bold">
      A brief job description is listed below:
    </p>
    <ul class="list-disc ml-8 mt-4 mb-8 lh-29px">
      <li class="text-black">
        Assisting patients with personal hygiene such as bathing, dental care
        and grooming
      </li>
      <li class="text-black">Helping the patients with visits to doctor</li>
      <li class="text-black">
        Providing companionship, entertainment, and social engagement to clients
      </li>
      <li class="text-black">Serving meals to the patient</li>
      <li class="text-black">
        Carrying out errands like medicine and grocery shopping
      </li>
      <li class="text-black">
        Bathing, dressing, grooming, eating, using the restroom, walking, and
        climbing stairs for clients
      </li>
      <li class="text-black">
        Provide regular updates to the family on the status and progress of the
        patient's condition
      </li>
    </ul>

    <p class="text-black text-base mb-2">
      Please fill in your details and preferences. We will contact you when we
      get suitable requirements from our clients and partners.
    </p>

    <p class="text-black text-base mb-2">Thank you for registering with us.</p>

    <p class="text-black text-base mb-8">Caregiver Saathi</p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
